(function ($) {
  const sizeMap = {
    '4': '35',
    '5': '35.5',
    '5.5': '36',
    '6': '37',
    '6.5': '37.5',
    '7': '38',
    '7.5': '38.5',
    '8': '39',
    '8.5': '39.5',
    '9': '40',
    '10': '41',
    '11': '42',
    '12': '43',
    '12.5': '44',
    '13': '45',
    '14': '46',
  };

  function renderSizeSelection($select) {
    const $form = $select.closest('form');
    const currentSystem = $form.find('.toggle-size.active').data('system') || 'us';

    let $container = $select.next('.ws-size-selection');
    if ($container.length === 0) {
      $container = $('<div class="ws-size-selection">').insertAfter($select);
    }

    $container.empty();

    $select.find('option').each(function () {
      const $option = $(this);
      if ($option.val() === '') return;

      const val = $option.val();
      let text = $option.text();

      // Only convert if system is 'eu' and map exists
      if (currentSystem === 'eu' && sizeMap[text]) {
        text = sizeMap[text];
      }

      const $div = $(`<div class="ws-size-selection-option" data-value="${val}">${text}</div>`);

      if ($option.is(':disabled')) $div.addClass('disabled');
      if ($option.is(':selected')) $div.addClass('selected');

      $container.append($div);
    });
  }

  $(document).on('click', '.ws-size-selection-option', function (e) {
    e.preventDefault();
    if ($(this).hasClass('disabled')) return;

    const $this = $(this);
    const value = $this.data('value');
    const $container = $this.closest('.ws-size-selection');
    const $select = $container.prev('select');

    $select.val(value).trigger('change');
    $select.closest('form').trigger('check_variations');
  });

  $(document).on('click', '.toggle-size', function (e) {
    e.preventDefault();
    const $this = $(this);
    const $form = $this.closest('form');

    $form.find('.toggle-size').removeClass('active');
    $this.addClass('active');

    renderSizeSelection($form.find('.wolkyshop_sizes_dropdown'));
  });

  $.fn.wsSizeSelection = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            if (typeof this.resizeMenu === 'function') {
                this.resizeMenu();
            }
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      const $select = $(this);
      if ($select.data('ws-size-selection')) return;
      $select.data('ws-size-selection', true);

      renderSizeSelection($select);
    });
  };

  $(document).on('woocommerce_update_variation_values', function () {
    $('.wolkyshop_sizes_dropdown').each(function () {
      renderSizeSelection($(this));
    });
  });
})(jQuery);
